import { Mods, mods } from '@approvalmax/theme';
import { StyledMods } from '@styled-kit/mods';
import { BankLogoImage } from 'shared/components';
import styled from 'styled-components';

export const StyledImg = styled(BankLogoImage)<StyledMods<Mods<'disabled'>>>`
    ${mods.disabled.true`
        filter: grayscale(100%);
    `}
`;
